import React, { useEffect } from 'react';
import { Result, Button } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';


const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // 获取支付相关参数
  const sessionId = searchParams.get('session_id');
  const amount = searchParams.get('amount');
  const currency = searchParams.get('currency');

  useEffect(() => {
    // 这里可以添加支付成功后的逻辑
    // 比如向后端确认支付状态，更新用户积分等
    console.log('支付成功页面加载', { sessionId, amount, currency });
  }, [sessionId, amount, currency]);

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const handleViewCredits = () => {
    navigate('/dashboard'); // 可以导航到积分页面
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{ 
        background: 'white', 
        borderRadius: '12px', 
        padding: '40px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '90%'
      }}>
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          status="success"
          title="Payment Successful!"
          subTitle={
            <div>
              <p>Thank you for your purchase. Your account credits have been topped up successfully.</p>
              {amount && currency && (
                <p style={{ color: '#666', fontSize: '14px' }}>
                  Amount paid: {amount} {currency?.toUpperCase()}
                </p>
              )}
              {sessionId && (
                <p style={{ color: '#999', fontSize: '12px' }}>
                  Transaction ID: {sessionId}
                </p>
              )}
            </div>
          }
          extra={[
            <Button type="primary" key="dashboard" onClick={handleBackToDashboard}>
              Back to Home
            </Button>,
            <Button key="credits" onClick={handleViewCredits}>
              View Credits
            </Button>,
          ]}
        />
      </div>
    </div>
  );
};

export default PaymentSuccess; 